import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { RiskPage } from '../pages/RiskPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/risk')({
  component: Risk,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function Risk() {
  return (
    <MainLayout>
      <RiskPage />
    </MainLayout>
  )
}
